import React, { useEffect, useState } from "react"
import styles from "./configTextListItems.module.css"
import BreakForm from "../Form/BreakForm"
import { HiPencil, HiPlus } from "react-icons/hi"
import FormGroupInline from "../Form/FormGroupInline"
import Button from "../Form/Button"
import FormGroup from "../Form/FormGroup"
import Input from "../Form/Input"
import ColorPicker from "../Form/ColorPicker"
import { MdColorLens, MdOutlineDelete } from "react-icons/md"

const ConfigTextListItems = ({ title, editable, isNew = false, value = [{ name: "" }], placeholder = "", textNotItems = "", colorSelect = false, showAction = true, isItemReadOnly = () => false, getItemIndicator = () => "", setEdit = () => { }, onSubmit = () => { }, onCancel = () => { } }) => {
    const [data, setData] = useState(value)

    useEffect(() => {
        setData(value)
    }, [value])

    useEffect(() => {
        if (editable && data.length === 0) {
            handleAddItem()
        }
    }, [editable])

    const handleChangeValue = (key, value, index) => {
        setData(previusValue => {
            const newValue = [...previusValue]
            newValue[index] = { ...newValue[index], [key]: value }
            return newValue
        })
    }

    const handleAddItem = (e) => {
        e?.preventDefault()
        setData(previusValue => {
            const newValue = [...previusValue]
            newValue.push({})
            return newValue
        })
    }

    const handleRemoveItem = (e, index) => {
        e?.preventDefault()
        setData(previusValue => {
            const newValue = [...previusValue]
            newValue.splice(index, 1)
            return newValue
        })
    }

    const handleCancelChanges = (e) => {
        setData(value)
        onCancel(e)
    }

    return (
        <form onSubmit={(e) => onSubmit(e, isNew, data)}>
            <BreakForm
                title={title}
                iconAction={(editable || isNew) ? <HiPlus /> : <HiPencil />}
                actionVariant={(editable || isNew) ? "primary" : "secondary"}
                handleAction={(editable || isNew) ? handleAddItem : setEdit}
                showAction={(!editable || showAction)}
            />
            {data?.length > 0 && data.map((item, index) => {
                const itemReadOnly = isItemReadOnly(item)
                const itemIndicator = getItemIndicator(item)

                return (
                    <FormGroupInline key={item?._id || index} btnAction={(editable || isNew) && !itemReadOnly} uniqueInput={true}>
                        <FormGroup className={styles.nameField}>
                            <Input type="text" placeholder={placeholder} value={item?.name ?? ""} onChange={(e) => handleChangeValue("name", e.target.value, index)} disabled={itemReadOnly || (!editable && !isNew)} />
                            {itemIndicator && <span className={styles.itemIndicator}>{itemIndicator}</span>}
                            {(item.countDiscards >= 0) &&
                                <div className={styles.countItems}>
                                    {item.countDiscards}
                                </div>
                            }
                        </FormGroup>
                        {colorSelect &&
                            <FormGroup fullWidth={false}>
                                <ColorPicker
                                    value={item?.color || "#ffffff"}
                                    onChange={(color) => handleChangeValue("color", color, index)}
                                    label="Cor"
                                    icon={<MdColorLens />}
                                    disabled={itemReadOnly || (!editable && !isNew)}
                                    className={styles.colorPicker}
                                />
                            </FormGroup>
                        }
                        {(editable || isNew) && !itemReadOnly &&
                            <Button variant='secondary' className='action' onClick={(e) => handleRemoveItem(e, index)}><MdOutlineDelete /></Button>
                        }
                    </FormGroupInline>
                )
            })}
            {(data?.length === 0 && !(editable || isNew)) &&
                <span>{textNotItems}</span>
            }
            {(editable || isNew) &&
                <div className={styles.footer}>
                    <FormGroupInline>
                        <Button variant='primary' type="submit">Salvar</Button>
                        <Button variant='secondary' onClick={handleCancelChanges}>Cancelar</Button>
                    </FormGroupInline>
                </div>
            }
        </form>
    )
}

export default ConfigTextListItems
